import getConfig from "next/config";
import { useDatadogRum } from "@src/utils/datadog";

const {
  publicRuntimeConfig: { deployEnvironment, DATADOG_APPLICATION_ID, DATADOG_CLIENT_TOKEN },
} = getConfig();

export const useDatadog = () => {
  useDatadogRum({
    allowedTracingUrls: [/^https:\/\/.*\.chime\.com/],
    enabled: process.env.NODE_ENV === "production",
    env: deployEnvironment,
    applicationId: DATADOG_APPLICATION_ID,
    clientToken: DATADOG_CLIENT_TOKEN,
    service: "identity-client",
    site: "datadoghq.com",
    sessionSampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  });
};
